export const isListingDurationAvailable = (
  duration: unknown
): duration is number =>
  typeof duration === 'number' && Number.isFinite(duration) && duration >= 0
